import SpriteSymbol from "../../../../../shared/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../shared/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-left",
  "use": "icon-arrow-left-usage",
  "viewBox": "0 0 27 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 27 20\" id=\"icon-arrow-left\"><path d=\"M1 10.25h25M10 20L0 10 10 0\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"square\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol